import styled from "styled-components";
import { device } from "../device";

const TextBtn = styled.button`
    position: relative;

    padding: 6px 16px;

    font-size: 16px;
    font-weight: 400;

    background: transparent;
    border: none;
    cursor: pointer;
    text-align: left;

    transition: color .2s ease-in-out, background .2s ease-in-out;
    &:focus {
        outline: 0;
    }
    &.active {
        color: var(--brand);
    }
    &.parent {
        display: block;
        padding: 6px 24px;
        width: 100%;

        font-weight: 500;
        &.active-parent {
            background: var(--light-gray1);
        }
    }
    @media ${device.lg} {
        font-size: 18px;
    }
`;

export default TextBtn;